import Menu from 'components/Menu'
import RoundyContainer from 'components/RoundyContainer'
import AddressDisclosureAgreement from 'components/StraightThroughAddressComp/DisclosureAgreement/AddressDisclosureAgreement'
import { HouseholdChangeContext, HouseholdChangeContextComp } from 'components/StraightThroughHouseholdComp/HouseholdContext/HouseholdChangeContext'
import HouseholdProgressBreadCrumb from 'components/StraightThroughHouseholdComp/HouseholdProgressBar/HouseholdProgressBreadCrumb'
import StraightThrough_HouseholdMain from 'components/StraightThroughHouseholdComp/StraightThrough_HouseholdMain'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { storageData } from 'services/Services'

const Household = (props) => {
  const navigate = useNavigate()
  const { userData } = props.user
  const [showModal, setShowModal] = useState(true);
  const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

  const handleClose = () => {
    setShowModal(false);
    userData["disclosureModal"] = true
    storageData.setItem("userData", JSON.stringify(userData));
  }

  useEffect(() => {
    window.scrollTo(0, 0)

    // Redirect to maintenance page if maintenance is on for Add Vehicle Endorsement
    if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementHousehold")) {
      navigate("/maintenance")
      return
    }
  }, [])

  return (
    <>
      <HouseholdChangeContextComp>
        <Menu Title={"UPDATE HOUSEHOLD"} FirstName={userData.firstName} userData={userData} />
        <HouseholdProgressBreadCrumb requestContext={HouseholdChangeContext} screen={"Household"} />
        <RoundyContainer
          Content={StraightThrough_HouseholdMain}
          NoRoundy
        />

        {!userData?.disclosureModal &&
          <AddressDisclosureAgreement
            showModal={showModal}
            handleClose={handleClose}
            title="DISCLOSURE AGREEMENT"
            policyState={userData.state}
          />
        }
      </HouseholdChangeContextComp>
    </>
  )
}

export default Household